export default "__VITE_ASSET__C2J8loqg__"